import { ServerService } from 'app/model/services/api-services/server.service';
import { PrivacyService } from './../../model/services/privacy.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { ModalLoginInfo } from 'app/types/modal-login-message';



@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormComponent implements OnInit {

  constructor(private cdr: ChangeDetectorRef, private shh: PrivacyService, private server: ServerService) { }

  @ViewChild('pw_input') pwInput!: ElementRef<HTMLInputElement>;
  private _ready = false;
  private _identity: string = '';
  private _password: string = '';

  public logoDark = '/assets/images/alphasol_black.png'
  public hasError = false;
  public errorMessage: string = '';
  public set identity(id: string) {
    this._identity = id;
  }
  public get identity(): string {
    return this._identity;
  }
  public set password(pw: string) {
    this._password = this.shh.GetS('encrypted password', pw);
    this.Refresh();
  }
  public get password(): string {
    return '';
  }

  @Output()
  public status = new EventEmitter<ModalLoginInfo>();


  ngOnInit(): void {
    this._ready = true;
    this.ClearPW();
  }
  Refresh() {
    this.cdr.detectChanges();
  }
  ClearPW() {
    if (!this.pwInput) return;
    this.pwInput.nativeElement.value = '';
  }
  Authenticate() {
    this.server.Authenticate(this._identity, this.shh.SGet('encrypted password', this._password)).then((response: any) => {
      if (response.status === 'error') {
        this.errorMessage = response.message;
        this.hasError = true;
      } else {
        this.errorMessage = '';
        this.hasError = false;
      }
      this.status.emit({
        status: response.status,
        message: this.errorMessage,
        authInfo: response
      });
    }).catch((reason: any) => {
      this.errorMessage = 'There was an unknown problem logging in.';
      this.hasError = true;
      this.Refresh();
    }).finally(() => {
      this.ClearPW();
    });

  }

}
